/**
 * DLC Identity Color Constants
 *
 * Canonical source: see wiki/decisions/dlc-color-canon.md.
 * Mirror of the CSS tokens at frontend/src/styles/dlc-tokens.css for
 * JSX consumers that need to set color/background via inline style.
 *
 * Usage:
 *   import { DLC_COLORS } from '../constants/dlcColors';
 *   <span style={{ color: DLC_COLORS.naplex.primary }}>...</span>
 *   <div style={{ background: `rgba(${DLC_COLORS.ptcb.rgb}, 0.12)` }}>...</div>
 *
 * Never hardcode a DLC hex — always reference these tokens. If you need a
 * color that isn't here, the canon is wrong (raise it) — don't add a new shade.
 */

export const DLC_COLORS = Object.freeze({
  naplex: Object.freeze({
    primary: '#22c55e',
    hover: '#34d399',
    rgb: '34, 197, 94',
  }),
  mpje: Object.freeze({
    primary: '#3b82f6',
    hover: '#60a5fa',
    rgb: '59, 130, 246',
  }),
  ptcb: Object.freeze({
    primary: '#fbbf24',
    hover: '#fcd34d',
    rgb: '245, 158, 11',
  }),
});

/**
 * Convenience helper: build an rgba string for a given DLC + alpha.
 * Returns null if the DLC key is unknown so callers don't silently
 * render the wrong color.
 *
 *   dlcRgba('naplex', 0.12) -> "rgba(34, 197, 94, 0.12)"
 */
export function dlcRgba(dlc, alpha) {
  const entry = DLC_COLORS[dlc];
  if (!entry) return null;
  return `rgba(${entry.rgb}, ${alpha})`;
}
